import { Wizard } from '../../../components/Wizard/Wizard';
import { ChooseCountryWizardStepRedesign } from '../redesign-components/ChooseCountryRedesign/ChooseCountryWizardStepRedesign';
import { ResponsibleSocialPlayTermsRedesign } from '../redesign-components/ResponsibleSocialPlayTermsRedesign/ResponsibleSocialPlayTermsRedesign';

import {
  SignupWizardOrderRedesignFlow,
  SignUpWizardStepsRedesign,
  authWizardWrapperStyle,
  PostSignupWizardOrderRedesignFlow,
} from './constants';
import { PostSignUpWizardProvider } from './postSignUpWizard.provider';
import styles from './RedesignWizard.module.scss';

const PostSignUpWizardComponentsRedesign = {
  [SignUpWizardStepsRedesign.ChooseCountry]: ChooseCountryWizardStepRedesign,
  [SignUpWizardStepsRedesign.ResponsibleSocialPlay]: ResponsibleSocialPlayTermsRedesign,
};

const getSteps = () => {
  return {
    order: SignupWizardOrderRedesignFlow,
    sortedComponents: PostSignupWizardOrderRedesignFlow.map((value) => PostSignUpWizardComponentsRedesign[value]),
  };
};

export default function PostSignUpWizard() {
  const { sortedComponents } = getSteps();

  return (
    <PostSignUpWizardProvider>
      <Wizard
        classNameSteps={styles.redesignFlowSteps}
        classNameStepWrapper={styles.redesignFlowStepWrapper}
        steps={sortedComponents}
        wizardFlowParams={{ isRedesignSteps: true }}
        wrapperStyle={authWizardWrapperStyle}
      />
    </PostSignUpWizardProvider>
  );
}
